// extracted by mini-css-extract-plugin
module.exports = {"main":"e_Q","gdrInfo":"e_R","gdrLink":"e_S","gdrButton":"e_T"};